import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {Converter} from 'showdown';
import {finalize} from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import {getTranslation} from 'shared/helpers/get-translation';
import {HistoryEntry, HistoryEntryType} from '../../model/model';
import {HistoryService} from '../../services/history.service';

const LABEL_FORMAT: string = 'dddd, DD.MM.YYYY';

import { Browser } from '@capacitor/browser';
import { NavService } from 'shared/nav/nav.service';

@Component({
  selector: 'history-page',
  templateUrl: 'history-page.html',
  styleUrls: ['history-page.scss'],
})
export class HistoryPage {

  // virtual won't show anything if initialized without an entry,
  // so we make a "no-entries"-entry
  public historyEntries: Array<HistoryEntry> = [{
    type: HistoryEntryType.DialogAnswer,
    createdAt: '',
    description: {
      de: '',
      en: '',
    },
    text: {
      de: 'Tippbewertungen und Dialogantworten werden geladen',
      en: 'Tip ratings and dialog answers are loading',
    },
    responseType: '0',
    response: '',
  }];
  public isLoading: boolean = false;

  public audioUrl: Array<SafeResourceUrl> = [];
  public videoUrl: Array<SafeResourceUrl> = [];


  constructor(
    private navService: NavService,
    private translateService: TranslateService,
    private historyService: HistoryService,
    private sanitizer: DomSanitizer,
  ) { }

  public get hasHistoryEntries(): boolean {
    return this.historyEntries && this.historyEntries.length > 0;
  }

  private ionViewWillEnter(): void {
    this.isLoading = true;
    this.historyService.getHistory()
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe((entries) => { this.historyEntries = entries; });
  }

  public getLocalizedDate(time: string): string {
    return moment(time).format(LABEL_FORMAT);
  }

  public getLocalizedHistoryEntryTitle(text: Dictionary<string>): string {
    console.log("##"+getTranslation(text, this.translateService));
    return getTranslation(text, this.translateService);
  }

  public getLocalizedHistoryEntryDescription(description: Dictionary<string>, i: number): string {
    const translation: string = getTranslation(description, this.translateService);
    let s = this._convertTextToMarkdown(translation);
    if ( s.search(/(<a\s+href="(https:\/\/everydaycounts.podigee.io\/[^"]+)">)/i) >= 0) {
      const all: string = RegExp.$1;
      let url: string = RegExp.$2;
      // console.log(RegExp.$2);
      url = url.replace(/\?.*/, '');
      url += '/embed?context=external&amp=false';
      this.audioUrl[i] = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      s = s.replace(all, '');
    }
    else if ( s.search(/(<a\s+href="(https:\/\/www.youtube.com\/embed\/[^"]+)">(([^<]*)<\/a>|))/i) >= 0) {
      const all: string = RegExp.$1;
      let url: string = RegExp.$2;
      url = url.replace('autoplay=1', '');
      this.videoUrl[i] = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      s = s.replace(all, '');
    }
    return s;
  }

  private _convertTextToMarkdown(text: string): string {
    const converter = new Converter();
    converter.setFlavor('github');
    let s = converter.makeHtml(text);
    while (/(\{content:\s*([^\}]+)\})/.test(s)) {
      const subst = RegExp.$1;
      const name =  RegExp.$2;
      s = s.replace(subst, '<a href="https://dummy.de/'+name+'">'+name+'</a>');
    } 
    return s;
  }

  public getMinLabel(answer: HistoryEntry): string {
    return answer.minLabel !== undefined ? getTranslation(answer.minLabel, this.translateService) : undefined;
  }

  public getMaxLabel(answer: HistoryEntry): string {
    return answer.maxLabel !== undefined ? getTranslation(answer.maxLabel, this.translateService) : undefined;
  }

  public interceptClick(event: Event): void {
    const target: HTMLElement = <HTMLElement> event.target;
    if (!(target instanceof HTMLAnchorElement) && !(target.parentElement instanceof HTMLAnchorElement)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const anchor: HTMLAnchorElement = <HTMLAnchorElement> (target.tagName === 'A' ? target : target.parentElement);
    const href = anchor.href;
    if ( href.indexOf('https://dummy.de/') == 0) {
      this.navService.push('content', {selContentTitle: decodeURI(href.substring(17))});
    }
    else {
      Browser.open({url: href});
    }
  }
}
